import React, { useState } from "react";
import LanguageSelector from '../languages/LanguageSelector';
import "../style/styles.css";
import LoginModal from "../pages/LoginModal";
import RegisterModal from "../pages/RegisterModal";
import Impressum from "../pages/Impressum";
import Datenschutz from "../pages/Datenschutz";
import AGB from "../pages/AGB";
import Contact from "../pages/Contact";
import AboutUs from "../pages/AboutUs";
import { MENU_LOGO_BACKGROUND, MENU_WHITE_BACKGROUND } from "../constants";
import { CONFIG } from "../config";

export default function MenuLogin(props) {
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const logo = require(`../../vendors/${CONFIG.PROJECTNAME}/logo.png`);

  const handleShowRegisterModal = (value) => {
    setShowRegisterModal(value);
  };

  const parentHandleToken = (isLogged) => {
    props.setAppToken(isLogged);
  };


  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className={`w-full px-1 ${MENU_WHITE_BACKGROUND ? "text-menu-secondary-color bg-white" : "text-white bg-menu-secondary-color"}`}>
      <div className="w-full px-2 flex justify-between items-center">
        <div className="grid flex-none items-center content-center py-1 ">
          <img className={`flex items-center justify-center h-12 p-1 ${MENU_LOGO_BACKGROUND ? "bg-white rounded-sm" : ""}`} src={logo} alt="Logo" />
        </div>
        <div className="hidden md:flex space-x-4">
          <LoginModal
            setShowRegisterModal={handleShowRegisterModal}

            parentHandleToken={parentHandleToken}
            onGetItems={() => props.onGetItems()}
            onGetCategories={() => props.onGetCategories()} />
          {

            <RegisterModal showModal={showRegisterModal} setShowModal={handleShowRegisterModal}></RegisterModal>


          }
          <LanguageSelector></LanguageSelector>
        </div>
        <div className="md:hidden mr-2">
          <button onClick={toggleMenu} className="text-white">
            ☰
          </button>
        </div>
      </div>
      {isOpen && (
        <div className="md:hidden bg-menu-secondary-color text-white p-4 w-full">
          <div ></div>
          <div className="text-start space-y-4">
            <LanguageSelector></LanguageSelector>
            <LoginModal
              setShowRegisterModal={handleShowRegisterModal}
              parentHandleToken={parentHandleToken}
              onGetItems={() => props.onGetItems()}
              onGetCategories={() => props.onGetCategories()} />

            {

              <RegisterModal showModal={showRegisterModal} setShowModal={handleShowRegisterModal} />


            }
            <hr></hr>
            <Impressum ShowImpressum={(value) => props.ShowImpressum(value)} />
            <Datenschutz ShowDatenschutz={(value) => props.ShowDatenschutz(value)} />
            <AGB ShowAGB={(value) => props.ShowAGB(value)} />
            <Contact ShowContact={(value) => props.ShowContact(value)} />
            <AboutUs ShowAboutUs={(value) => props.ShowAboutUs(value)} />

          </div>
        </div>
      )}
    </nav>
  );
}
